'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _createLoginClient = require('../../helpers/createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _ClientError = require('../../helpers/ClientError');

var _PopupType = require('../../helpers/PopupType');

var _Preauthorize = require('../../helpers/Preauthorize');

var _Product = require('../../helpers/Product');

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _SessionStorage = require('../../helpers/SessionStorage');

var _SSO = require('../../helpers/SSO');

var _URL = require('../../helpers/URL');

var _PostLoginFlowStrategySelector = require('../../login/strategy/PostLoginFlowStrategySelector');

var _PostLoginFlowStrategySelector2 = _interopRequireDefault(_PostLoginFlowStrategySelector);

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _SwitchProvider = require('./SwitchProvider.scss');

var _SwitchProvider2 = _interopRequireDefault(_SwitchProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchProvider = (_dec = (0, _reactRedux.connect)(function (state) {
  return { appInfo: state.appInfo, auth: state.auth, log: state.log };
}, { changePopupType: _popup.changePopupType, linkSecureToken: _auth.linkSecureToken, linkIdentityToAccount: _auth.linkIdentityToAccount, linkSSOToken: _auth.linkSSOToken, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SwitchProvider, _Component);

  function SwitchProvider() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SwitchProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwitchProvider.__proto__ || (0, _getPrototypeOf2.default)(SwitchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      oldProvider: null,
      newProvider: null
    }, _this.onSuccess = function (nextProps) {
      var loginStrategy = _PostLoginFlowStrategySelector2.default.getPostLoginFlowStrategy(nextProps.auth, _this.props.appInfo, _this.props.pushState, _this.props.log);
      loginStrategy.handleUserInfoResponse(_this.props.linkIdentityToAccount, _this.props.linkSecureToken, _this.props.linkSSOToken);
    }, _this.onContinue = function () {
      (0, _SessionStorage.saveDataInSessionStorage)(_SessionStorage.SessionStorageKeys.OldSessionId, '');
      _URL.URL.removeUnusedParam();
      _this.onSuccess(_this.props);
    }, _this.onSwitchProvider = function () {
      var query = _this.context.router.location.query;
      if ((0, _Preauthorize.isPreauthorize)(query)) {
        _this.props.linkSecureToken(query.token, query.operator_id);
      } else if (_SSO.SSO.isSSO(query)) {
        _this.props.linkSSOToken(query.operatorToken, query.operator_id);
      } else {
        var oldSessionId = (0, _SessionStorage.getDataFromSessionStorage)(_SessionStorage.SessionStorageKeys.OldSessionId);
        _this.props.linkIdentityToAccount(oldSessionId);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SwitchProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var query = this.context.router.location.query;

      if ((0, _Preauthorize.isPreauthorize)(query) || _SSO.SSO.isSSO(query)) {
        var operatorId = query.operator_id;
        (0, _createLoginClient2.default)().then(function (loginClient) {
          return loginClient.operator.getOperator({
            id: operatorId,
            languageTag: _this2.props.auth.lang,
            clientId: _this2.props.auth.clientId
          }, { responseContentType: 'application/json' }).then(function (result) {
            (0, _Provider.setProviderInStorage)(_SessionStorage.SessionStorageKeys.LinkAccountProviderKey, result.obj.operator);
            _this2.setState({ newProvider: result.obj.operator });
          }).catch(function (error) {
            (0, _Error.logError)(error.statusText);
          });
        }).catch(function (error) {
          (0, _ClientError.createLoginClientError)(error, new Error().stack, _this2.props.pushState, _this2.props.auth);
        });
      } else {
        var provider = (0, _Provider.getProviderFromStorage)(_SessionStorage.SessionStorageKeys.LinkAccountProviderKey);
        this.setState({ newProvider: provider });
      }

      (0, _createLoginClient2.default)().then(function (loginClient) {
        return loginClient.operator.getOperator({
          id: _this2.props.auth.userInfo.account.operatorId,
          languageTag: _this2.props.auth.lang,
          clientId: _this2.props.auth.clientId }, { responseContentType: 'application/json' }).then(function (result) {
          _this2.setState({ oldProvider: result.obj.operator });
        }).catch(function (error) {
          (0, _Error.logError)(error.statusText);
        });
      }).catch(function (error) {
        (0, _ClientError.createLoginClientError)(error, new Error().stack, _this2.props.pushState, _this2.props.auth);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.linkingSecureToken && !nextProps.auth.linkingSecureToken || this.props.auth.linkingSSOToken && !nextProps.auth.linkingSSOToken) {
        if (nextProps.auth.error) {
          this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LinkExpired));
        } else {
          this.onSuccess(nextProps);
        }
      } else if (this.props.auth.linkingIdentityToAccount && !nextProps.auth.linkingIdentityToAccount) {
        // Link Identity to Account
        if (nextProps.auth.error) {
          this.props.changePopupType(_PopupType.PopupId.UnknownError); // TODO GALVIP-3063 Error
        } else {
          this.onSuccess(nextProps);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var formatMessage = this.props.intl.formatMessage;

      var newProviderStyle = _SwitchProvider2.default.newProvider + ' ' + _SwitchProvider2.default.provider;
      var oldProviderStyle = _SwitchProvider2.default.provider;
      return _react2.default.createElement(
        'div',
        { className: _SwitchProvider2.default.switchProvider },
        _react2.default.createElement(
          'div',
          { className: _SwitchProvider2.default.switchProviderContent },
          _react2.default.createElement(
            'div',
            { className: _SwitchProvider2.default.title },
            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.UniversalLoginTitle, {
              values: { product: formatMessage((0, _Product.getProductName)(this.props.auth.realm, this.props.auth.productName, this.props.auth.clientId)) }
            }))
          ),
          _react2.default.createElement(
            'div',
            { className: _SwitchProvider2.default.message },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.SwitchProviderMessage, {
              values: { provider: this.state.oldProvider ? this.state.oldProvider.name : '' }
            }))
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _SwitchProvider2.default.providers },
          _react2.default.createElement(
            'div',
            { className: newProviderStyle },
            _react2.default.createElement(_components.ProviderLogo, { className: _SwitchProvider2.default.logo, provider: this.state.newProvider }),
            _react2.default.createElement(_components.BaseButton, { className: _SwitchProvider2.default.button, onClick: this.onSwitchProvider, buttonString: _DefaultString.translations.SwitchProviderSwitchButton })
          ),
          _react2.default.createElement(
            'div',
            { className: _SwitchProvider2.default.seperator },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.Or)
          ),
          _react2.default.createElement(
            'div',
            { className: oldProviderStyle },
            _react2.default.createElement(_components.ProviderLogo, { className: _SwitchProvider2.default.logo, provider: this.state.oldProvider }),
            _react2.default.createElement(_components.BaseButton, { className: _SwitchProvider2.default.button, onClick: this.onContinue, buttonString: _DefaultString.translations.SwitchProviderContinueButton })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _SwitchProvider2.default.change },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.SwitchProviderChangeMessage)
        )
      );
    }
  }]);
  return SwitchProvider;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  intl: _reactIntl.intlShape.isRequired,
  linkIdentityToAccount: _react.PropTypes.func,
  linkSecureToken: _react.PropTypes.func.isRequired,
  linkSSOToken: _react.PropTypes.func.isRequired,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired,
  location: _react2.default.PropTypes.object
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(SwitchProvider);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SwitchProvider/SwitchProvider.js
// module id = 2022
// module chunks = 0